import { IncomingInfoRowProps } from '../types';

const IncomingInfoRow: React.FC<IncomingInfoRowProps> = ({ rows }) => (
    <div className="flex flex-col gap-y-1 text-sm">
        {rows.map(({ label, val }) => (
            <p key={label}>
                <span className="text-gray-400">{label}</span>
                {val && `: ${val}`}
            </p>
        ))}
    </div>
);
export default IncomingInfoRow;
